/**
 * Textos do painel "Perfil e regras deste exame" (E151.F2, GUS-174, ADR-0103 §4.2): o modo do
 * cadastro, o catálogo, o perfil situado pela data do ato, as leituras que podem decidir o caso e as
 * regras preparadas que ainda não decidem. É material da equipe: o cliente não escolhe a norma pela
 * interface.
 */
export const ptBRFormalizacao = {
  titulo: 'Perfil e regras deste exame',
  subtitulo: 'Informações usadas na análise; o cliente não escolhe a norma pela interface.',
  carregando: 'Carregando o perfil do exame…',
  erro: 'Não foi possível carregar o perfil do exame. Tente novamente.',
  semPermissao: 'O perfil do exame é da equipe que atende o caso.',
  naoEncontrado: 'Caso não encontrado.',
  tentarDeNovo: 'Tentar de novo',
  aguardandoExame:
    'O perfil depende da data do ato e da modalidade, que saem do exame. Verifique o material na análise preliminar.',
  rotulos: {
    modo: 'Modo',
    catalogo: 'Catálogo',
    perfil: 'Perfil',
    dataDoAto: 'Data do ato',
    modalidade: 'Modalidade',
  },
  modo: {
    parte: 'PARTE: parecer técnico da instituição contratante',
    juizo: 'JUÍZO: apoio a perito nomeado, avaliação imparcial',
  },
  origemDoModo: {
    padrao: 'padrão do cadastro do caso',
    definido: 'definido no cadastro em {data}',
  },
  catalogo: '{versao} · {metodologia}',
  modalidade: {
    consignado_inss: 'Consignado do INSS',
    consignado_trabalhador: 'Consignado do trabalhador',
    outra: 'Outra folha, sem perfil no catálogo',
    indeterminada: 'Não identificada no material',
  },
  origemDasDatas: {
    adotada: '',
    hipotese: 'a data foi lida em mês e dia sem fonte que a fixe; as duas leituras seguem',
    fuso_presumido: 'o instante não declara fuso; as duas leituras do dia seguem',
  },
  porLeituraNormativa: 'O perfil depende de qual texto da norma vale nesta data.',
  marcoNaoConferido: 'O marco deste perfil vem de norma ainda não conferida.',
  leiturasQueDecidem: {
    parte: 'Leituras que podem decidir o caso, na ordem de prioridade',
    juizo: 'Leituras que precisam convergir',
  },
  primeira: 'Considerada primeiro',
  nenhumaLeitura: 'Nenhuma leitura ativa pode decidir este caso.',
  tese: 'Tese',
  fundamento: 'Fundamento',
  exigencias: 'O que esta leitura exige',
  provaAdicional: 'Procedimentos que não decidem nesta leitura (prova adicional quando cumpridos)',
  naoConferido: 'não conferido',
  naoAtivado: 'conferido, não ativado',
  naoExigidosNaData: 'Não exigidos na data do ato (a norma ainda não os exigia)',
  naoSeAplica: 'não se aplica',
  incidenciaNaoApurada: 'incidência não apurada',
  regrasQueNaoDecidem: 'Regras do perfil que não decidem o caso ({n})',
  pendencias: 'O que impede decidir',
  semPendencias: 'Nenhuma pendência na seleção do perfil.',
  // E162.F1.T12 (QA-10): sem pendência na seleção, mas com marco ou regra ainda não conferidos, a
  // tela não diz "nenhuma pendência" — diz o alcance.
  semPendenciasComRessalva:
    'Nada impede a seleção do perfil, mas há marco ou regra de norma ainda não conferidos (indicados acima): o que eles decidem fica pendente até a conferência.',
  categoria: {
    A: 'suprível por prova factual',
    B: 'evento oficial',
    C: 'vedação ou forma exclusiva',
  },
  fonte: {
    lei: 'lei',
    infralegal: 'norma infralegal',
  },
  motivo: {
    modo_nao_aplicavel: 'não vale neste modo',
    preparada: 'texto ainda não conferido',
    verificada_sem_ativacao: 'conferida, sem ativação',
    posterior_sem_retroacao: 'posterior à data do ato, sem retroação',
    revogada_ou_encerrada: 'revogada ou encerrada na data do ato',
    norma_sem_vigencia_conferida: 'vigência não conferida',
    norma_suspensa: 'norma suspensa',
    eficacia_condicionada: 'eficácia depende de regulamento',
    subsidiaria: 'tese subsidiária: não serve de fundamento',
  },
  pendencia: {
    sem_data_do_ato: 'Sem data do ato no material.',
    data_entre_perfis: 'As leituras da data do ato caem em perfis diferentes.',
    modalidade_indeterminada: 'O material não identifica a modalidade.',
    modalidade_sem_perfil: 'A operação não tem perfil no catálogo.',
    sem_perfil_na_data: 'Nenhum perfil cobre a data do ato.',
    sem_leitura_admissivel: 'Nenhuma leitura ativa vale para este perfil.',
    incidencia_nao_apurada: 'Falta apurar se a operação foi feita na plataforma digital.',
    leitura_pertinente_inativa: 'Leitura pertinente ainda não conferida impede a convergência.',
  },
} as const;
